import { getCalendarEntry } from '../selectors/calendarsCacheSelectors';
import Calendar from '../store/schema/Calendar';

export default function isGroupCalendar(calendar: Calendar): boolean {
    const calendarEntry = getCalendarEntry(calendar);
    return !!calendarEntry && calendarEntry.IsGroupMailboxCalendar;
}
